import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=20872cff"
import script from "./OrdersReport.vue?vue&type=script&lang=js"
export * from "./OrdersReport.vue?vue&type=script&lang=js"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=20872cff&prod&lang=scss"
import style1 from "./OrdersReport.vue?vue&type=style&index=1&id=20872cff&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports